import http from '@/http-common.js'

class EmployeesAdminService {
  basePathApiService = '/employees'

  getAll(params) {
    return http.get(this.basePathApiService, params)
  }
  create(createData) {
    return http.post(this.basePathApiService, createData)
  }
  editMultiple(id, editData) {
    return http.put(this.basePathApiService + `/${id}`, editData)
  }
  delete(id) {
    return http.delete(this.basePathApiService + `/${id}`)
  }
}
export default new EmployeesAdminService()
